<template>
  <div class="actionlist">
    <transition name="sideDown">
      <div class="content" ref="content" v-show="showMenu">
        <type-list v-for="(item, index) in menuList" :item="item" :index="index" :key="item.id"
                   :name="item.name" :icon="item.icon" :align="item.align" :clickItem="clickItem" :count="item.count" :action="item.action" :color="item.color">
         </type-list>
      </div>
    </transition>
    <transition name="fade">
      <div>
        <div class="mask" v-show="showMenu" @click="hideMenuList" @touchmove.stop.prevent="stopTouch($event)"></div>
      </div>
    </transition>
  </div>
</template>

<script>
  import store from '../../store/index'
  import * as Util from '../../common/js/util'
  import typelist from './menu_item'
  export default {
    data () {
      return {
        isShow: false,
        allMenu: {
          upload: {
            name: '上传',
            icon: 'icon-upload',
            type: 'event',
            action: 'upload',
            align: 'left'
          },
          create: {
            name: '新建文件夹',
            icon: 'icon-new-folder',
            type: 'event',
            action: 'newFolder',
            align: 'left'
          }
        }
      }
    },
    methods: {
      stopTouch (event) {
        return
      },
      clickItem (obj) {
        console.log(obj.action + '===actionList==' + obj.type)
        switch (obj.action) {
          case `upload`:
            this.hideMenuList()
            // 判断是否为wifi
            if (store.state.currentNetworkType === 0) {
              let params = {
                isShow: true,
                message: '无网络',
                iconClass: 'icon-error' // iconClass根据实际情况传相对应的值
              }
              store.commit('setToast', params)
              return
            }
            if (store.state.onlyWIFI && store.state.currentNetworkType !== 1) {
              let params = {
                isShow: true,
                message: '仅在WIFI环境下上传',
                iconClass: 'icon-error' // iconClass根据实际情况传相对应的值
              }
              store.commit('setToast', params)
              return
            }
            document.getElementById('lenovobox_upload_btn').click() // 将上传触发弹框放在这里，解决点击上传无反应的问题
//            store.commit('setStartUpload', true)
            break
          case `newFolder`:
            this.hideMenuList()
            store.commit('setAddFolderShow', true)
            break
        }
      },
      hideMenuList () {
        store.dispatch({
          type: 'hideActionMenuList'
        })
      }
    },
    computed: {
      showMenu () {
        this.isShow = this.$store.getters.getActionListIsShow ? this.$store.getters.getActionListIsShow : false
        return this.$store.getters.getActionListIsShow ? this.$store.getters.getActionListIsShow : false
      },
      menuList () {
        var menus = []
        var auth = Util.getCSSActionByCode(this.$store.getters.getCurrentFolderInfo.access_mode).authCSS.split(':')
        for (var o in auth) {
          if (this.allMenu[auth[o]]) {
            menus.push(this.allMenu[auth[o]])
          }
        }
        return menus
      }
    },
    watch: {
      isShow: function (newisShow) {
        if (newisShow) {
          // this.$refs.content.style.height = `${this.$store.getters.getShowMenuInfo.content.length * 50 + 20}px`
        }
      }
    },
    components: {
      'type-list': typelist
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus">
  @import "../../common/stylus/global.styl"
  .actionlist
    font-size: 12px
    .content
      background: rgba(255,255,255,0.9)
      position: fixed
      z-index: 16
      height: auto
      top: 1.16rem
      left: 0
      right: 0
      &.sideUp-enter-to, &.sideUp-leave-to
        transition: transform 0.3s
      &.sideUp-enter, &.sideUp-leave-to
        transform: translate3d(0, 100%, 0)
      .title
        margin: 0
        height: 20px
        line-height: 20px
        padding: 0 15px
      .typelist
        margin-left: .52rem
        height: 1.44rem
        line-height: 1.44rem
        .typelist-detail
          height: 1.44rem
          line-height: 1.44rem
          span
            line-height: 1.44rem
            .name
              margin-left: .52rem
              display: inline-block
              width: 8.36rem
              border-bottom:1px solid  $split_color_fat
              padding-bottom: 1.5px
       .typelist:last-child .typelist-detail span .name
          border: none
    .mask
      top: 1.16rem
</style>



// WEBPACK FOOTER //
// menu_current_folder.vue?0bfe9e2d